module.exports = __webpack_public_path__ + "exo-latin-800italic.ba95c7ebbd3ee83362b2.svg";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-800italic.svg
// module id = ../../../../typeface-exo/files/exo-latin-800italic.svg
// module chunks = styles